import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {PriceLabelComponent} from "./price-label.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        PriceLabelComponent,
    ],
    exports: [
        PriceLabelComponent
    ],
})
export class PriceLabelModule {
}